
<!-- eslint-disable vue/no-v-html -->
<div
	v-tooltip="tooltipObj"
	class="icon-container"
	:name="computedName"
	:size="size"
	:disabled="disabled"
	:effects="effects && state !== 'wiggle'"
	:style="{ transform: `rotate(${rotate}deg)` }"
	:data-animate="animate"
	@click="handleClick"
>
	<div class="icon" :type="type" :state="state" :data-color="color" v-html="svg" />
</div>
